import { PlusIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export interface ClientTeamMemberFooterProps {
  onUnknownGuestClick?: () => void;
  onCreateClick?: () => void;
  /** Callback to close the dropdown after an action */
  onClose?: () => void;
}

/**
 * Footer component for ClientTeamMemberAutoComplete with standard action buttons.
 *
 * Provides two standard buttons:
 * - Unknown Guest: For selecting an unknown/generic guest
 * - Create New Guest: For creating a new guest record
 *
 * @example
 * ```tsx
 * <ClientTeamMemberFooter
 *   onUnknownGuestClick={() => handleSelectUnknown()}
 *   onCreateClick={() => openCreateModal()}
 * />
 * ```
 */
export const ClientTeamMemberFooter = ({
  onUnknownGuestClick,
  onCreateClick,
}: ClientTeamMemberFooterProps) => {
  return (
    <div className="space-y-1.5 border-t border-gray-200 bg-gray-50 p-3">
      {onUnknownGuestClick && (
        <button
          className="group flex w-full items-center gap-2.5 rounded-md border border-gray-200 bg-white px-3 py-2 text-left transition-all hover:border-gray-300 hover:shadow-sm"
          onClick={onUnknownGuestClick}
          type="button"
        >
          <QuestionMarkCircleIcon className="size-4 shrink-0 text-gray-400" />
          <span className="text-sm font-medium text-gray-700">
            Unknown Guest
          </span>
        </button>
      )}

      {onCreateClick && (
        <button
          className="group flex w-full items-center gap-2.5 rounded-md border border-gray-200 bg-white px-3 py-2 text-left transition-all hover:border-gray-300 hover:shadow-sm"
          onClick={onCreateClick}
          type="button"
        >
          <PlusIcon className="size-4 shrink-0 text-gray-400" />
          <span className="text-sm font-medium text-gray-700">
            Create New Guest
          </span>
        </button>
      )}
    </div>
  );
};
